// Google Review App Accessibility Fix
// 修复 Google Review App 在 Shopify 网站上的无障碍访问问题
// 立即輸出，確保腳本已載入
console.log('🔍 Google Review Accessibility Fix: Script loaded');
console.log('TEST: Script is executing');

// 確保在 DOM 準備好後執行
(function() {
  'use strict';
  
  console.log('TEST: IIFE is executing');
  
  // 設置 aria-hidden 和 tabindex 的函數
  function setAccessibilityAttributes() {
    console.log('#### execute once ####');
    
    // 針對所有以 I0_ 開頭的 iframe（Google Review App 的 iframe）
    const googleIframes = document.querySelectorAll('iframe[id^="I0_"]');
    console.log('Found iframe[id^="I0_"]:', googleIframes.length);
    googleIframes.forEach(function(iframe, index) {
      if (!iframe.hasAttribute('aria-hidden') || iframe.getAttribute('aria-hidden') !== 'true') {
        iframe.setAttribute('aria-hidden', 'true');
        console.log('✅ Set aria-hidden on iframe #' + index + ' (ID: ' + iframe.id + ')');
      }
      if (!iframe.hasAttribute('tabindex') || iframe.getAttribute('tabindex') !== '-1') {
        iframe.setAttribute('tabindex', '-1');
        console.log('✅ Set tabindex on iframe #' + index + ' (ID: ' + iframe.id + ')');
      }
      // 添加 title 屬性以滿足無障礙要求
      if (!iframe.hasAttribute('title')) {
        iframe.setAttribute('title', 'Google Store Quality Badge');
        console.log('✅ Set title on iframe #' + index + ' (ID: ' + iframe.id + ')');
      }
    });
    
    // 針對所有帶有 _ngcontent 屬性的 div
    // 注意：由於 iframe 是跨域的，我們只能處理主文檔中的元素
    const divsWithNgContent = Array.from(document.querySelectorAll('div')).filter(function(div) {
      return Array.from(div.attributes).some(function(attr) {
        return attr.name.startsWith('_ngcontent');
      });
    });
    console.log('Found divs with _ngcontent:', divsWithNgContent.length);
    divsWithNgContent.forEach(function(div, index) {
      if (!div.hasAttribute('aria-hidden') || div.getAttribute('aria-hidden') !== 'true') {
        div.setAttribute('aria-hidden', 'true');
        console.log('✅ Set aria-hidden on div #' + index);
      }
      if (!div.hasAttribute('tabindex') || div.getAttribute('tabindex') !== '-1') {
        div.setAttribute('tabindex', '-1');
        console.log('✅ Set tabindex on div #' + index);
      }
    });
    
    // 針對 iframe 內部的按鈕（通過查找 iframe 附近的按鈕元素）
    // 由於無法直接訪問 iframe 內容，我們查找與 iframe 相關的按鈕
    const googleIframeArray = Array.from(googleIframes);
    googleIframeArray.forEach(function(iframe) {
      // 查找 iframe 父元素中的按鈕
      const parent = iframe.parentElement;
      if (parent) {
        const buttons = parent.querySelectorAll('button[aria-label*="Google"], button[aria-label*="Store quality"], button[mat-fab]');
        buttons.forEach(function(button) {
          // 檢查按鈕是否有可聚焦的子元素
          const focusableDescendants = button.querySelectorAll('[tabindex="0"], [tabindex]:not([tabindex="-1"])');
          if (focusableDescendants.length > 0) {
            focusableDescendants.forEach(function(descendant) {
              if (descendant.hasAttribute('tabindex') && descendant.getAttribute('tabindex') !== '-1') {
                descendant.setAttribute('tabindex', '-1');
                console.log('✅ Set tabindex="-1" on nested focusable element');
              }
            });
          }
        });
      }
    });
    
    // 也檢查可能的其他選擇器
    const otherGoogleIframes = document.querySelectorAll('iframe[src*="google.com"][src*="merchantverse"], iframe[ng-non-bindable]');
    console.log('Found other Google iframes:', otherGoogleIframes.length);
    otherGoogleIframes.forEach(function(iframe) {
      if (!iframe.hasAttribute('aria-hidden') || iframe.getAttribute('aria-hidden') !== 'true') {
        iframe.setAttribute('aria-hidden', 'true');
        iframe.setAttribute('tabindex', '-1');
        if (!iframe.hasAttribute('title')) {
          iframe.setAttribute('title', 'Google Store Quality Badge');
        }
        console.log('✅ Set attributes on Google iframe');
      }
    });
  }
  
  // 初始化函數
  function init() {
    console.log('🚀 Initializing Google Review Accessibility Fix');
    
    // 使用 MutationObserver 監聽 DOM 變化
    const observer = new MutationObserver(function(mutations) {
      let shouldCheck = false;
      
      mutations.forEach(function(mutation) {
        // 檢查是否有新增的節點
        if (mutation.addedNodes && mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) { // Element node
              // 檢查是否是目標元素或包含目標元素
              if ((node.tagName === 'IFRAME' && node.id && node.id.startsWith('I0_')) ||
                  (node.tagName === 'IFRAME' && node.hasAttribute('ng-non-bindable')) ||
                  (node.tagName === 'DIV' && Array.from(node.attributes).some(function(attr) { return attr.name.startsWith('_ngcontent'); })) ||
                  (node.querySelector && (
                    node.querySelector('iframe[id^="I0_"]') || 
                    node.querySelector('iframe[ng-non-bindable]') ||
                    node.querySelector('div[_ngcontent]')
                  ))) {
                console.log('🎯 Found target element:', node);
                shouldCheck = true;
              }
            }
          });
        }
        
        // 檢查屬性變化（如果 ID 被動態添加）
        if (mutation.type === 'attributes') {
          const target = mutation.target;
          if (mutation.attributeName === 'id' && target.id && target.id.startsWith('I0_')) {
            console.log('🎯 ID attribute changed to I0_*');
            shouldCheck = true;
          }
          if (mutation.attributeName && mutation.attributeName.startsWith('_ngcontent')) {
            console.log('🎯 _ngcontent attribute added');
            shouldCheck = true;
          }
        }
      });
      
      if (shouldCheck) {
        // 使用 setTimeout 確保元素完全渲染
        setTimeout(setAccessibilityAttributes, 100);
      }
    });
    
    // 開始觀察整個 document body
    if (document.body) {
      console.log('👀 Starting MutationObserver on document.body');
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['id', 'ng-non-bindable', '_ngcontent']
      });
    } else {
      console.log('⚠️ document.body not ready, waiting for DOMContentLoaded');
      document.addEventListener('DOMContentLoaded', function() {
        console.log('👀 Starting MutationObserver on document.body (after DOMContentLoaded)');
        observer.observe(document.body, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['id', 'ng-non-bindable', '_ngcontent']
        });
      });
    }
    
    // 立即執行一次（如果元素已經存在）
    console.log('🚀 Initial check');
    setAccessibilityAttributes();
    
    // 延遲執行，確保覆蓋所有情況
    console.log('⏰ Scheduling delayed checks');
    setTimeout(function() {
      console.log('⏰ Delayed check 1 (500ms)');
      setAccessibilityAttributes();
    }, 500);
    
    setTimeout(function() {
      console.log('⏰ Delayed check 2 (1000ms)');
      setAccessibilityAttributes();
    }, 1000);
    
    setTimeout(function() {
      console.log('⏰ Delayed check 3 (2000ms)');
      setAccessibilityAttributes();
    }, 2000);
    
    setTimeout(function() {
      console.log('⏰ Delayed check 4 (3000ms)');
      setAccessibilityAttributes();
    }, 3000);
    
    setTimeout(function() {
      console.log('⏰ Delayed check 5 (5000ms)');
      setAccessibilityAttributes();
    }, 5000);
    
    console.log('✅ Google Review Accessibility Fix: Script initialized');
  }
  
  // 根據 DOM 狀態決定何時執行
  if (document.readyState === 'loading') {
    console.log('📋 Document is loading, waiting for DOMContentLoaded');
    document.addEventListener('DOMContentLoaded', init);
  } else {
    console.log('📋 Document already loaded, initializing immediately');
    // DOM 已經準備好，立即執行
    if (document.body) {
      init();
    } else {
      // 如果 body 還沒準備好，等待一下
      setTimeout(function() {
        if (document.body) {
          init();
        } else {
          console.log('⚠️ Still no body, waiting for window load');
          window.addEventListener('load', init);
        }
      }, 100);
    }
  }
  
  // 監聽 window load 事件作為備用
  window.addEventListener('load', function() {
    console.log('📦 Window loaded, checking again');
    setTimeout(function() {
      setAccessibilityAttributes();
    }, 1000);
  });
})();
